import { WebCoinIcon } from '@wwe-portal/ui/components/icons';
import { Dialog, CommonDialogLayout } from '@wwe-portal/ui/components/dialog';

export interface OutStockWebCoinDialogProps {
  onClose?: () => void;
  onChange?: () => void;
  open?: boolean;
  data?: {
    actionElement?: React.ReactNode;
  };
}
export function OutStockWebCoinDialog({
  onClose,
  open = true,
  data,
}: Readonly<OutStockWebCoinDialogProps>) {
  return (
    <Dialog
      onOpenChange={(isOpen: boolean) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        actionElement={data?.actionElement}
        closable
        dataId="OutStockWebCoinDialog"
        descriptionElement={
          <div className="mt-5">
            <p className="text-text300 mb-2 text-xl font-semibold leading-6">
              Not enough Web Coins
            </p>
            <span className="text-text400 text-sm font-medium leading-[26px]">
              Buy Web Coin Packs in the Special Offers Shop, or by competing in
              Trivia Rumble
            </span>
          </div>
        }
        hasBackground
        imageElement={
          <div className="border-text700 flex size-[80px] items-center justify-center rounded-full border-4 border-solid">
            <WebCoinIcon className="size-[60px]" />
          </div>
        }
        layoutClass="px-6"
        onClose={onClose}
        titleElement={undefined}
      />
    </Dialog>
  );
}

export default OutStockWebCoinDialog;
